// src/components/ModalHistorial.jsx
import React, { useState } from "react";
import Modal from "react-modal";
import Avatar from "./Avatar";
import { formatShortName } from "../hooks/useUserAvatar";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "480px",
    maxHeight: "80vh",
    padding: "20px 24px 24px",
    borderRadius: "18px",
    border: "none",
    boxShadow: "0 18px 45px rgba(15, 23, 42, 0.25)",
    overflow: "hidden",
    fontFamily: "Inter, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(15, 23, 42, 0.35)",
    zIndex: 9999,
  },
};

const ui = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
  },
  closeBtn: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 16,
    color: "#6b7280",
    padding: 4,
  },

  tabs: {
    display: "flex",
    gap: 8,
    borderBottom: "1px solid #e5e7eb",
    marginBottom: 12,
  },
  tabBase: {
    position: "relative",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: "6px 10px 10px",
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    color: "#6b7280",
  },
  tabActiveExtra: {
    color: "#111827",
    fontWeight: 600,
  },
  tabBadge: {
    fontSize: 12,
    padding: "2px 6px",
    borderRadius: 999,
    background: "#E6EDFF",
    color: "#1D4ED8",
  },
  tabUnderline: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: -1,
    height: 2,
    background: "#2563eb",
    borderRadius: 999,
  },

  body: {
    marginTop: 10,
    maxHeight: "45vh", // un poco menos para dejar espacio al composer
    overflowY: "auto",
  },
  empty: {
    fontSize: 13,
    color: "#9ca3af",
  },

  // Tarjetas
  item: {
    background: "#F9FAFB",
    borderRadius: 12,
    padding: "10px 12px",
    marginBottom: 10,
    border: "1px solid #E5E7EB",
  },
  itemHeader: {
    display: "flex",
    gap: 8,
    marginBottom: 6,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
  },
  itemTitle: {
    margin: 0,
    fontSize: 13,
    color: "#111827",
  },
  itemUserName: {
    fontWeight: 600,
    color: "#111827",
  },
  itemAction: {
    fontWeight: 400,
    color: "#111827",
  },
  itemMeta: {
    margin: "2px 0 0",
    fontSize: 11,
    color: "#6B7280",
  },

  diffBox: {
    marginTop: 4,
    fontSize: 12,
  },
  prev: {
    margin: 0,
    fontSize: 12,
  },
  prevSpan: {
    textDecoration: "line-through",
    color: "#DC2626",
  },
  nuevo: {
    margin: 0,
    fontSize: 12,
  },
  nuevoSpan: {
    color: "#16A34A",
  },

  // Archivos
  itemFile: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "#F9FAFB",
    borderRadius: 12,
    padding: "10px 12px",
    marginBottom: 10,
    border: "1px solid #E5E7EB",
  },
  fileIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#EEF2FF", // opcional, un fondito suave
    color: "#000", // color del icono
    fontSize: 18,
    flexShrink: 0,
  },
  fileInfo: {
    flex: 1,
  },
  timeText: {
    fontSize: 11,
    color: "#6B7280",
  },

  // Notas existentes
  noteText: {
    fontSize: 12,
    color: "#4B5563",
    margin: 0,
    lineHeight: 1.5,
  },
  noteBubble: {
    marginTop: 8,
    padding: "10px 12px",
    borderRadius: 12,
    background: "#F3F4F6",
    border: "1px solid #E5E7EB",
  },
  noteItemUserName: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#111827",
  },
  noteEditBtn: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 4,
    fontSize: 14,
    color: "#9CA3AF",
  },
  noteEditBtnHidden: {
    opacity: 0,
    pointerEvents: "none",
  },

  // Composer de notas (tipo chat)
  noteComposer: {
    marginTop: 10,
    paddingTop: 10,
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  },
  noteComposerForm: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 6,
    marginRight: 0,
    background: "#F9FAFB",
    borderRadius: 12,
    padding: "6px 8px 8px",
    border: "1px solid #E5E7EB",
  },
  noteTextarea: {
    width: "100%",
    minHeight: 60,
    maxHeight: 120,
    resize: "vertical",
    fontSize: 12,
    padding: "6px 4px 4px",
    borderRadius: 12,
    border: "none",
    fontFamily: "Inter, sans-serif",
    outline: "none",
    background: "transparent",
  },
  noteComposerFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 2,
  },
  noteHint: {
    fontSize: 11,
    color: "#9CA3AF",
  },
  noteBtnRow: {
    display: "flex",
    gap: 8,
  },
  notePrimaryBtn: {
    padding: "6px 12px",
    borderRadius: 999,
    border: "none",
    backgroundColor: "#2563EB",
    color: "#FFFFFF",
    fontSize: 12,
    cursor: "pointer",
  },
  noteSecondaryBtn: {
    padding: "6px 10px",
    borderRadius: 999,
    border: "none",
    backgroundColor: "transparent",
    color: "#6B7280",
    fontSize: 12,
    cursor: "pointer",
  },
};

const TABS = [
  { id: "cambios", label: "Cambios" },
  { id: "archivos", label: "Archivos relacionados" },
  { id: "notas", label: "Notas" },
];

function ModalHistorial({
  isOpen,
  onClose,
  cambios = [],
  archivos = [],
  notas = [],
  currentUserId,
  onSaveNote, // (texto, noteId?) => Promise
}) {
  const [activeTab, setActiveTab] = useState("cambios");

  // estado para el "chat" de notas
  const [noteDraft, setNoteDraft] = useState("");
  const [editingNote, setEditingNote] = useState(null);
  const [saving, setSaving] = useState(false);

  const getItemsForTab = () => {
    if (activeTab === "cambios") return cambios;
    if (activeTab === "archivos") return archivos;
    if (activeTab === "notas") return notas;
    return [];
  };

  const items = getItemsForTab();

  const handleStartEditNote = (note) => {
    setEditingNote(note);
    setNoteDraft(note.texto || "");
  };

  const handleCancelEdit = () => {
    setEditingNote(null);
    setNoteDraft("");
  };

  const doSave = async () => {
    const text = noteDraft.trim();
    if (!text || !onSaveNote) return;
    setSaving(true);
    try {
      await onSaveNote(text, editingNote?.id || null);
      // al terminar, limpiamos para volver a modo "nueva nota"
      setNoteDraft("");
      setEditingNote(null);
    } finally {
      setSaving(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await doSave();
  };

  const handleTextareaKeyDown = async (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      await doSave();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Historial"
      style={customStyles}
    >
      {/* Header */}
      <div style={ui.header}>
        <h3 style={ui.title}>Historial</h3>
        <button style={ui.closeBtn} onClick={onClose}>
          <i className="bi bi-x-lg" />
        </button>
      </div>

      {/* Tabs */}
      <div style={ui.tabs}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          const count =
            tab.id === "cambios"
              ? cambios.length
              : tab.id === "archivos"
              ? archivos.length
              : notas.length;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              style={{
                ...ui.tabBase,
                ...(isActive ? ui.tabActiveExtra : {}),
              }}
            >
              <span>{tab.label}</span>
              <span style={ui.tabBadge}>{count}</span>
              {isActive && <span style={ui.tabUnderline} />}
            </button>
          );
        })}
      </div>

      {/* Contenido (lista) */}
      <div style={ui.body}>
        {/* TAB CAMBIOS */}
        {activeTab === "cambios" && (
          <>
            {items.length === 0 ? (
              <p style={ui.empty}>No hay cambios registrados aún.</p>
            ) : (
              items.map((item, idx) => {
                const nombre = item.usuarioNombre || item.usuario || "Usuario";

                return (
                  <div key={idx} style={ui.item}>
                    <div style={ui.itemHeader}>
                      <div style={ui.avatar}>
                        <Avatar userId={item.usuarioId} size={32} />
                      </div>
                      <div>
                        <p style={ui.itemTitle}>
                          <span style={ui.itemUserName}>
                            {formatShortName(nombre)}
                          </span>{" "}
                          <span style={ui.itemAction}>
                            {item.descripcion || "realizó un cambio"}
                          </span>
                        </p>

                        <p style={ui.itemMeta}>
                          {item.fecha || "Fecha"} – {item.hora || "Hora"}
                        </p>
                      </div>
                    </div>

                    {(item.anterior || item.nuevo) && (
                      <div style={ui.diffBox}>
                        {item.anterior && (
                          <p style={ui.prev}>
                            Anterior:{" "}
                            <span style={ui.prevSpan}>{item.anterior}</span>
                          </p>
                        )}
                        {item.nuevo && (
                          <p style={ui.nuevo}>
                            Nuevo:{" "}
                            <span style={ui.nuevoSpan}>{item.nuevo}</span>
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </>
        )}

        {/* TAB ARCHIVOS */}
        {activeTab === "archivos" && (
          <>
            {items.length === 0 ? (
              <p style={ui.empty}>No hay archivos relacionados aún.</p>
            ) : (
              items.map((file, idx) => (
                <div key={idx} style={ui.itemFile}>
                  <div style={ui.fileIcon}>
                    <i className="bi bi-file-earmark-text" />
                  </div>
                  <div style={ui.fileInfo}>
                    <p style={ui.itemTitle}>{file.nombre || "Archivo"}</p>
                    <p style={ui.itemMeta}>
                      {file.descripcion || "Documento relacionado"}
                    </p>
                  </div>
                  <p style={ui.timeText}>{file.hace || "Hace unas horas"}</p>
                </div>
              ))
            )}
          </>
        )}

        {/* TAB NOTAS (lista tipo chat) */}
        {activeTab === "notas" && (
          <>
            {items.length > 0 &&
              items.map((note, idx) => {
                const nombre = note.usuarioNombre || note.usuario || "Usuario";
                const canEdit =
                  currentUserId && note.usuarioId === currentUserId;

                return (
                  <div key={idx} style={ui.item}>
                    {/* Header de la nota */}
                    <div
                      style={{
                        ...ui.itemHeader,
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", gap: 8 }}>
                        <div style={ui.avatar}>
                          <Avatar userId={note.usuarioId} size={32} />
                        </div>
                        <div>
                          <p style={ui.noteItemUserName}>
                            {formatShortName(nombre)}
                          </p>
                          <p style={ui.itemMeta}>
                            {note.fecha || "Fecha"} – {note.hora || "Hora"}
                          </p>
                        </div>
                      </div>

                      {/* Botón editar SOLO si la nota es del usuario actual */}
                      <button
                        type="button"
                        style={{
                          ...ui.noteEditBtn,
                          ...(canEdit ? {} : ui.noteEditBtnHidden),
                        }}
                        onClick={() => canEdit && handleStartEditNote(note)}
                        title={canEdit ? "Editar nota" : ""}
                      >
                        <i className="bi bi-pencil" />
                      </button>
                    </div>

                    {/* Burbuja de texto de nota */}
                    <div style={ui.noteBubble}>
                      <p style={ui.noteText}>
                        {note.texto || "Contenido de la nota..."}
                      </p>
                    </div>
                  </div>
                );
              })}
          </>
        )}
      </div>

      {/* Composer para crear/editar notas (tipo chat) */}
      {activeTab === "notas" && (
        <div style={ui.noteComposer}>
          {currentUserId && (
            <div style={ui.avatar}>
              <Avatar userId={currentUserId} size={32} />
            </div>
          )}

          <form style={ui.noteComposerForm} onSubmit={handleSubmit}>
            <textarea
              style={ui.noteTextarea}
              placeholder="Escribe una nota interna para esta remisión..."
              value={noteDraft}
              onChange={(e) => setNoteDraft(e.target.value)}
              onKeyDown={handleTextareaKeyDown}
            />

            <div style={ui.noteComposerFooter}>
              <div style={ui.noteBtnRow}>
                {editingNote && (
                  <button
                    type="button"
                    style={ui.noteSecondaryBtn}
                    onClick={handleCancelEdit}
                    disabled={saving}
                  >
                    Cancelar
                  </button>
                )}
                <button
                  type="submit"
                  style={ui.notePrimaryBtn}
                  disabled={!noteDraft.trim() || saving}
                >
                  {editingNote ? "Guardar cambios" : "Agregar nota"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </Modal>
  );
}

export default ModalHistorial;
